import { reportApi } from '../http/httpClient'

export interface ReportWithdraws {
  user: string
  cpf: string
  value: number
  updatedAt: string
  status: 'PENDING' | 'PAID'

  team?: string
  manager?: string
  supervisor?: string
  leader?: string
  pix_fee?: number
}

export interface ReportWithdrawsResponse {
  withdraws: ReportWithdraws[]
  pagination: {
    skip: number
    limit: number
    sort: string
    total: number
  }
}

export interface ReportWithdrawsParams {
  search?: string
  sellerIds?: string
  startDate?: string
  endDate?: string
  maxValue?: string
  minValue?: string
  limit?: number
  skip?: number
  sort?: string
}

export async function reportWithdraws(
  params?: ReportWithdrawsParams | undefined,
) {
  const { data } = await reportApi.get<ReportWithdrawsResponse>(
    '/report/withdraws',
    {
      params,
    },
  )

  return data
}
